import { gql } from '@apollo/client';

export const GET_COMPANY = gql`
  query GetCompany {
    company {
      id
      defaultProjectId
      tenantId
      name
      headquarter
      industry {
        id
        name
      }
      subIndustry {
        id
        name
      }
      status
      employeesNum
      companyDomain
      accessScope
      accountType
      shortTermUpperBound
      mediumTermUpperBound
      context
      llmMonthlyBudgetEur
      llmBudgetEnforcementEnabled
    }
  }
`;
